module.exports = __webpack_public_path__ + "media/desktop.250f924e.webm";